import React from 'react';
import {Card} from 'antd';
import {
    ClockCircleFilled,
    CheckCircleFilled,
    CloseCircleFilled,
    AppstoreFilled,
    StopFilled,
} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';
import {ReviewTaskTab} from '../graphql/types/ReviewTaskType';

interface ReviewTaskTabCardsProps {
    getCount: (tab: ReviewTaskTab) => number | undefined;
    loading: boolean;
}

interface TabCardSpec {
    key: ReviewTaskTab;
    titleKey: string;
    icon: React.ReactNode;
    iconBg: string;
    iconColor: string;
}

const TAB_CARD_SPECS: TabCardSpec[] = [
    {
        key: ReviewTaskTab.ALL,
        titleKey: 'reviewTask.tabs.ALL',
        icon: <AppstoreFilled />,
        iconBg: '#f0e6ff',
        iconColor: '#722ed1',
    },
    {
        key: ReviewTaskTab.PENDING,
        titleKey: 'reviewTask.tabs.PENDING',
        icon: <ClockCircleFilled />,
        iconBg: '#e6f0ff',
        iconColor: '#1677ff',
    },
    {
        key: ReviewTaskTab.APPROVED,
        titleKey: 'reviewTask.tabs.APPROVED',
        icon: <CheckCircleFilled />,
        iconBg: '#e6f7ec',
        iconColor: '#52c41a',
    },
    {
        key: ReviewTaskTab.REJECTED,
        titleKey: 'reviewTask.tabs.REJECTED',
        icon: <CloseCircleFilled />,
        iconBg: '#fde7e9',
        iconColor: '#ff4d4f',
    },
    {
        key: ReviewTaskTab.CANCELLED,
        titleKey: 'reviewTask.tabs.CANCELLED',
        icon: <StopFilled />,
        iconBg: '#f5f5f5',
        iconColor: '#8c8c8c',
    },
];

const ReviewTaskTabCards: React.FC<ReviewTaskTabCardsProps> = ({getCount, loading}) => {
    const {t} = useTranslation();

    return (
        <div className="flex gap-3 mb-3">
            {TAB_CARD_SPECS.map((spec) => {
                const count = getCount(spec.key);
                const display = loading && count === undefined ? '...' : count ?? 0;
                return (
                    <Card
                        key={spec.key}
                        styles={{body: {padding: '12px 16px'}}}
                        style={{flex: 1, background: '#fafafa', borderColor: '#f0f0f0'}}
                    >
                        <div className="flex items-center justify-between">
                            <div>
                                <div className="text-xs text-gray-500 mb-0.5">
                                    {t(spec.titleKey)}
                                </div>
                                <div className="text-xl font-semibold text-gray-900 leading-none">
                                    {display}
                                </div>
                            </div>
                            <div
                                style={{
                                    width: 28,
                                    height: 28,
                                    borderRadius: '50%',
                                    background: spec.iconBg,
                                    color: spec.iconColor,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: 14,
                                }}
                            >
                                {spec.icon}
                            </div>
                        </div>
                    </Card>
                );
            })}
        </div>
    );
};

export default ReviewTaskTabCards;
